import { DatePicker } from 'antd'
import { useCallback, useMemo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'
import localeFr from 'antd/es/date-picker/locale/fr_FR'
import localeDe from 'antd/es/date-picker/locale/de_DE'
import get from 'lodash/get'
import noop from 'lodash/noop'
import { useRouter } from 'next/router'
import { maskInput } from 'vanilla-text-mask'

import { useTranslations } from 'common/language'
import classNames from './styles.module.scss'


const localizations = {
  'de': localeDe,
  'fr': localeFr,
}

DateInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  onChangeFormat: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  allowClear: PropTypes.bool,
  onDateChange: PropTypes.func,
}

DateInput.defaultProps = {
  format: 'DD.MM.YYYY',
  onChangeFormat: 'YYYY-MM-DD',
  value: undefined,
  size: undefined,
  className: undefined,
  placeholder: undefined,
  allowClear: false,
  onDateChange: noop,
}

export default function DateInput(props) {
  const { gettext } = useTranslations()
  const { locale } = useRouter()
  const [ inputRef, setInputRef ] = useState(null)
  const { onChange, format, onChangeFormat, value, size, className, placeholder = gettext('Select'), onDateChange, ...rest } = props
  const handleChange = useCallback((value, dateString) => {
    onChange(dateString ? value.format(onChangeFormat) : null)
    return onDateChange(dateString)
  }, [onChange, onDateChange])
  const formattedValue = useMemo(_ => value ? moment(value, onChangeFormat) : undefined, [value])
  const localization = useMemo(_ => get(localizations, locale, 'de'), [locale])
  useEffect(() => {
    if(inputRef) {
      var dateInput = inputRef.querySelector('input')
      dateInput.setAttribute('inputmode', 'numeric')
      dateInput.setAttribute('pattern', '//d*')

      var dateMask = [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
      // eslint-disable-next-line no-undef
      var maskedInputController = maskInput({
        inputElement: dateInput,
        mask: dateMask,
        guide: false,
        keepCharPositions: true,
      })

      return maskedInputController.destroy
    }
  }, [inputRef])
  return (
    <div ref={ref => setInputRef(ref)}>
      <DatePicker
        onChange={handleChange}
        format={format}
        value={formattedValue}
        showToday={false}
        locale={localization}
        className={cx(
          className,
          classNames.datepicker,
          classNames[size],
        )}
        suffixIcon={<FontAwesomeIcon className={classNames.dateIcon} icon={['far', 'calendar-alt']} />}
        placeholder={placeholder}
        {...rest}
      />
    </div>
  )
}
